<div>
  <p class="authentication__right__card_title">
    {{ 'LOGIN.PASSWORD_RESET.SUCCESS_STEP.TITLE' | translate }}
  </p>

  <p class="authentication__right__card_description">
    {{ 'LOGIN.PASSWORD_RESET.SUCCESS_STEP.DESCRIPTION' | translate }}
  </p>

  <a class="authentication__right__card_next mt-27" mat-raised-button (click)="backToLogin.next()">
    {{ 'LOGIN.PASSWORD_RESET.SUCCESS_STEP.BACK_TO_LOGIN' | translate }}
  </a>
</div>
